import { isNil, omitBy } from 'lodash/fp';

const makeGetCustomData =
  // @ts-expect-error - Automatic, Please fix when editing this file


    ({ reduxStore }) =>
    () => {
      const state = reduxStore.getState();

      const { customer } = state;

      return {
        custom: omitBy(isNil, {
          customer: customer
            ? omitBy(isNil, {
                frequency: customer?.frequency,
                incomeTier: customer?.incomeTier,
                incomeType: customer?.incomeType,
                lhc: customer?.lhc,
                scale: customer?.scale,
                state: customer?.state,
              })
            : null,
          history: customer?.history,
        }),
      };
    };

export default makeGetCustomData;
